import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import fetch from "cross-fetch";

export const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                uploadDetail: {
                    read(_, { args, toReference }) {
                        return toReference({
                            __typename: "UploadType",
                            id: args.uploadId
                        });
                    }
                },
                photoUploadQueueStatus: {
                    merge(existing, incoming) {
                        return incoming;
                    }
                },
                photoBatchQueueStatus: {
                    merge(existing, incoming) {
                        return incoming;
                    }
                }
            }
        }
    }
});

export const apolloClient = new ApolloClient({
    ssrMode: false,
    link: createHttpLink({
        // uri: () => window?._nounConfig?.localGraphqlEndpoint || "",
        uri: window?._nounConfig?.localGraphqlEndpoint,
        credentials: "include",
        fetch
    }),
    cache
});
